import { AxiosRequestConfig } from "axios";
import type { AxiosDataReturn, PaginatedResponse } from "../types/generic";
import api from "./api-instance";
import { toast } from "react-toastify";
import { IUser } from "../types/user";

export const usersList = async (args?: AxiosRequestConfig<any>) => {
  try {
    const res = await api.get<AxiosDataReturn<PaginatedResponse<IUser>>>(
      "/users/admin",
      args
    );
    return res?.data?.data;
  } catch (e) {
    toast.error("Something went wrong", { toastId: "api-error" });
    throw e;
  }
};

export const exportUsers = async (args?: AxiosRequestConfig<any>) => {
  try {
    const res = await api.get<AxiosDataReturn<string>>(
      "/users/admin/export",
      args
    );
    return res?.data?.data;
  } catch (e) {
    toast.error("Something went wrong", { toastId: "api-error" });
    throw e;
  }
};
